import CouponList from './CouponList';
import CouponProdList from './CouponProdList';

const ACTION = {
  ...CouponList.ACTION,
  ...CouponProdList.ACTION,
};

const ACTION_TYPES = {
  ...CouponList.ACTION_TYPES,
  ...CouponProdList.ACTION_TYPES,
};

const Coupon = {
  ACTION,
  ACTION_TYPES
}

export default Coupon;